import { LeftOutlined } from '@ant-design/icons'

type Props = {
  onClick?: any
  text?: string
  url?: string
  className?: string
}
export const ButtonBack = ({ onClick, text = '戻る', className }: Props) => {
  return (
    <div className={`mt-[70px] font-bold ${className}`}>
      <div className="flex items-center gap-1 text-[#00C4C4] text-base hover:cursor-pointer" onClick={onClick}>
        <LeftOutlined />
        <p>{text}</p>
      </div>
    </div>
  )
}
